module.exports = __webpack_public_path__ + "static/media/measure.5ca561ec.png";